import { RouteObject } from 'react-router-dom'

import { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import type { ModuleRouteObject, RouteObjectWithMeta } from '../navigation/routes'
import usePrompt from './usePrompt'
import type { WithLocationProps } from './withLocation'

export type RawNavigationRoutesFn = (navigation: Navigation<NavigationPaths>) => RouteObject[]

export type AppNavigationRoutesFn = (
  navigation: Navigation<NavigationPaths>
) => RouteObjectWithMeta[]

export type ModuleNavigationRoutesFn = (
  navigation: Navigation<NavigationPaths>
) => ModuleRouteObject[]

export type NavigationRoutesFn =
  | RawNavigationRoutesFn
  | AppNavigationRoutesFn
  | ModuleNavigationRoutesFn

function enforceStrictReturn<T>(value: T): T {
  return value
}
export const buildModuleRoute = (route: ModuleRouteObject) => enforceStrictReturn(route)
export const buildRoute = (route: RouteObjectWithMeta) => enforceStrictReturn(route)

export const buildNavigation = (navigationFn: NavigationRoutesFn) =>
  enforceStrictReturn(navigationFn)

export { usePrompt }

export type { WithLocationProps }
